module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "display-1 grey--text text--darken-2 text-xs-center"
  }, [_vm._v("Disclaimer")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('p', [_vm._v("Creating a job requires permission from Cubo. By accepting this disclaimer, you understand that creating a job without permission could result in you not being paid for the work carried out.")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-btn', {
    staticClass: "success",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.acceptDisclaimer
    }
  }, [_vm._v("Accept")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "offset-xs1": "",
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "error",
    attrs: {
      "block": ""
    },
    on: {
      "click": _vm.declineDisclaimer
    }
  }, [_vm._v("Decline")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fbd53c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Shared/DisclaimerDialog.vue
// module id = 673
// module chunks = 1